import { render, staticRenderFns } from "./HouseholdIncome.vue?vue&type=template&id=27a54fb6&"
import script from "./HouseholdIncome.vue?vue&type=script&lang=js&"
export * from "./HouseholdIncome.vue?vue&type=script&lang=js&"
import style0 from "./HouseholdIncome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports